// extracted by mini-css-extract-plugin
module.exports = {"root":"IconSuccess_root__y8XeT","fillColor":"IconSuccess_fillColor__3B-l8"};